// extracted by mini-css-extract-plugin
module.exports = {"page-error-holder":"page-not-found_page-error-holder__3rxkA"};